// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__1RWhB","Follow":"Footer_Follow__8Mfo-","Icons":"Footer_Icons__3H1uz","return":"Footer_return__hBxXH"};